// extracted by mini-css-extract-plugin
export default {"Overlay":"lightbox-prompt_Overlay__qt0xM","Frame":"lightbox-prompt_Frame__I5NpU","Title":"lightbox-prompt_Title__-lwzj"};